// import React from "react";
// import ReminderItem from "./ReminderItem";
// import "../../../../../../css/pages/ca_pages/finances/models/client_payments_model/ReminderSection.css";

import React from "react";
import ReminderItem from "./ReminderItem";

const ReminderSection = ({
    enabled,
    reminders,
    errors,
    onToggle,
    onAdd,
    onRemove,
    onDuplicate,
    onUpdate,
}) => {
    return (
        <section className="payment-form-section reminder-section">
            <div className="section-heading">
                <h3>Automatic Reminders</h3>

                <span>
                    Schedule reminders and customize how your client receives them.
                </span>
            </div>

            {/* MASTER TOGGLE */}

            <div className="reminder-master-toggle">
                <div>
                    <strong>
                        Enable automatic reminders
                    </strong>

                    <small>
                        Automatically remind the client about outstanding payments.
                    </small>
                </div>

                <label className="switch">
                    <input
                        type="checkbox"
                        checked={enabled}
                        onChange={(e) => onToggle(e.target.checked) }
                    />

                    <span className="slider" />
                </label>
            </div>

            {!enabled && (
                <div className="reminders-disabled-message">
                    <strong>
                        Automatic reminders are disabled.
                    </strong>

                    <span>
                        You can enable them later from the payment request.
                    </span>
                </div>
            )}

            {enabled && (
                <>
                    <div className="reminder-builder-header">
                        <div>
                            <strong>
                                Reminder schedule
                            </strong>

                            <span>
                                Add as many reminders as you need.
                            </span>
                        </div>

                        <span className="reminder-count">
                            {reminders.length}{" "}
                            {reminders.length === 1 ? "reminder" : "reminders"}
                        </span>
                    </div>

                    {errors.reminders && (
                        <small className="field-error">
                            {errors.reminders}
                        </small>
                    )}

                    <div className="reminder-list">
                        {reminders.map(
                            (reminder, index) => (
                                <ReminderItem
                                    key={reminder.id}
                                    reminder={reminder}
                                    index={index}
                                    errors={errors}
                                    canRemove={ reminders.length > 1 }
                                    onRemove={ onRemove }
                                    onDuplicate={ onDuplicate }
                                    onUpdate={ onUpdate }
                                />
                            )
                        )}
                    </div>

                    <button
                        type="button"
                        className="add-reminder-button"
                        onClick={onAdd}
                    >
                        <span>+</span>
                        Add another reminder
                    </button>

                    {/* SUMMARY */}
                    <div className="reminder-summary">
                        <div>
                            <strong>
                                Reminder Summary
                            </strong>

                            <span>
                                {reminders.length}{" "}
                                scheduled{" "}
                                {reminders.length === 1 ? "reminder" : "reminders"}
                            </span>
                        </div>

                        <div className="summary-channels">
                            {[ "email", "whatsapp", "sms" ].map((channel) => {
                                const count =
                                    reminders.filter(
                                        (reminder) =>
                                            reminder.channels.includes(channel)
                                    ).length;

                                if (!count) { return null; }

                                return (
                                    <span
                                        key={ channel }
                                        className={`summary-channel ${channel}`}
                                    >
                                        {channel}
                                        <strong>
                                            {count}
                                        </strong>
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                </>
            )}
        </section>
    );
};

export default ReminderSection;
